<mat-select #listTypeSelect [placeholder]="placeholder" (selectionChange)="onSelectionChange()"
    (openedChange)="openedChange($event)" [compareWith]="compareWith" [disabled]="isDisabled" [formControl]="selectCtrl"
    [tabIndex]="tabIndex">

    <mat-option *ngFor="let item of (surveyMailListTypes$ |async)" [value]="item.surveyMailListTypeId">
        {{'SurveyMailListTypeList.'+item.name |translate}}
    </mat-option>

</mat-select>